import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddPaymentModal({ onClose, onSuccess }) {
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState('');
  const [amount, setAmount] = useState('');
  const [paymentType, setPaymentType] = useState('cash');
  const [loading, setLoading] = useState(false);
  const [sendInvoice, setSendInvoice] = useState(true);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(`${API_URL}/get-customers`);
      setCustomers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getWhatsAppLink = (customer, paymentAmount, remainingBalance) => {
    const message = `*UMER POULTRY - PAYMENT RECEIPT*\n\n*Date:* ${new Date().toLocaleDateString()}\n*Customer:* ${customer.name}\n*Phone:* ${customer.phone}\n\n━━━━━━━━━━━━━━━━━━━━━\n*Payment Details*\n━━━━━━━━━━━━━━━━━━━━━\n💰 Amount Paid: Rs. ${paymentAmount}\n💳 Payment Method: ${paymentType.toUpperCase()}\n\n━━━━━━━━━━━━━━━━━━━━━\n*Balance Due:* Rs. ${remainingBalance}\n━━━━━━━━━━━━━━━━━━━━━\n\nThank you for your payment!\nUmer Poultry - From Farms to Shops\n📍 Contact: 0300-1234567`;
    
    return `https://wa.me/${customer.phone}?text=${encodeURIComponent(message)}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const selectedCustomer = customers.find(c => c.id === customerId);
      const newBalance = selectedCustomer.balance - parseFloat(amount);
      
      const response = await axios.post(`${API_URL}/add-payment`, {
        customer_id: customerId,
        amount: parseFloat(amount),
        payment_type: paymentType,
        collected_by: localStorage.getItem('userId')
      });
      
      if (sendInvoice && selectedCustomer) {
        const whatsappLink = getWhatsAppLink(selectedCustomer, amount, newBalance);
        window.open(whatsappLink, '_blank');
      }
      
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding payment: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Record Payment</h2>
        <form onSubmit={handleSubmit}>
          <select value={customerId} onChange={(e) => setCustomerId(e.target.value)} required>
            <option value="">Select Customer</option>
            {customers.map(c => (
              <option key={c.id} value={c.id}>
                {c.name} - Balance: Rs.{c.balance?.toLocaleString() || 0}
              </option>
            ))}
          </select>
          <input type="number" step="0.01" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} required />
          <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
            <option value="cash">Cash</option>
            <option value="online">Online</option>
          </select>
          
          <label className="checkbox-label">
            <input type="checkbox" checked={sendInvoice} onChange={(e) => setSendInvoice(e.target.checked)} />
            Send WhatsApp Receipt to Customer
          </label>
          
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>
              {loading ? 'Recording...' : 'Record Payment'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddPaymentModal;